import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MaterialAccountEdit',
  data: function data() {
    return {
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      imageUrl: '',
      form: {
        id: null,
        name: '',
        image: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入账号名称',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请上传账号头像',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downUrl + res.body.url;
      this.form.image = res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    // 打开弹窗时调用：重置并加载已有的唯一账号，有则填充为编辑
    initData: function initData() {
      if (this.$refs.form !== undefined) this.$refs.form.resetFields();
      this.form.id = null;
      this.form.name = null;
      this.form.image = null;
      this.imageUrl = '';
      this.initNetData();
    },
    initNetData: function initNetData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, item;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_MATERIAL_ACCOUNT_LIST({});
            case 1:
              res = _context.v;
              if (res.body && res.body.length > 0) {
                item = res.body[0];
                _this.form.id = item.id;
                _this.form.name = item.name;
                _this.form.image = item.image;
                _this.imageUrl = item.image ? _this.downUrl + item.image : '';
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_MATERIAL_ACCOUNT(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_MATERIAL_ACCOUNT(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.id != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};